import { render, staticRenderFns } from "./ChannelProviderDeleteDialog.vue?vue&type=template&id=0392991e&scoped=true"
import script from "./ChannelProviderDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ChannelProviderDeleteDialog.vue?vue&type=script&lang=js"
import style0 from "./ChannelProviderDeleteDialog.vue?vue&type=style&index=0&id=0392991e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0392991e",
  null
  
)

export default component.exports